document.querySelectorAll('.product_accordian_main .accordian_item').forEach((accordion, index) => {
  const header = accordion.querySelector('.accordian_item_questionsec');
  const contentSec = accordion.querySelector('.accordian_content_sec');
  const innerContent = accordion.querySelector('.accordian_content_inner');

  contentSec.style.overflow = 'hidden';
  contentSec.style.transition = 'height 0.3s ease';


    contentSec.style.height = '0px';
    header.classList.remove('opened');

  header.addEventListener('click', () => {
    const isOpen = contentSec.style.height !== '0px';

    document.querySelectorAll('.product_accordian_main .accordian_item').forEach(otherAccordion => {
      const otherContentSec = otherAccordion.querySelector('.accordian_content_sec');
      const otherHeader = otherAccordion.querySelector('.accordian_item_questionsec');

      if (otherAccordion !== accordion) {
        otherContentSec.style.height = '0px';
        otherHeader.classList.remove('opened');
      }
    });

    if (isOpen) {
      contentSec.style.height = '0px';
      header.classList.remove('opened');
    } else {
      const contentHeight = innerContent.scrollHeight;
      contentSec.style.height = contentHeight + 'px';
      header.classList.add('opened');
    }
  });
});